/*

new UICodeField(elemNode, {
    charsCount: 4,
    mask: "\\d",
    hiddenInputName: "code",
});

*/
class UICodeField {
    constructor(container, options = {}) {
        // Инициализация параметров
        this.container = container;
        this.charsCount = options.charsCount || 6;
        this.mask = options.mask || null;
        this.hiddenInputName = options.hiddenInputName || "code";
        this.attrs = options.attrs || {};
        this.currentValue = ""; // Хранение текущего значения
        
        // Создание и рендеринг UI
        this.render();
        this.bindEvents();
    }
    
    render() {
        // Очистка контейнера
        this.container.innerHTML = "";
        
        // Скрытый input для сохранения значения
        this.hiddenInput = document.createElement("input");
        this.hiddenInput.type = "hidden";
        this.hiddenInput.name = this.hiddenInputName;
        this.container.appendChild(this.hiddenInput);
        
        // Контейнер для input полей
        this.inputsContainer = document.createElement("div");
        this.inputsContainer.classList.add("ui-codefield-container");
        this.container.appendChild(this.inputsContainer);
        
        // Создание input полей
        this.inputs = [];
        for (let i = 0; i < this.charsCount; i++) {
            const input = document.createElement("input");
            input.type = "text";
            input.classList.add("ui-input-bordered");
            input.maxLength = 1;
            input.dataset.index = i;
            Object.keys(this.attrs).forEach(key => input.setAttribute(key, this.attrs[key]));
            if (this.mask) input.pattern = this.mask;
            this.inputsContainer.appendChild(input);
            this.inputs.push(input);
        }
        
        // Установка начального фокуса
        this.focusNextInput();
    }
    
    bindEvents() {
        this.inputs.forEach((input, index) => {
            input.addEventListener("input", (e) => this.handleInput(e, index));
            input.addEventListener("keydown", (e) => this.handleKeyDown(e, index));
            input.addEventListener("focus", () => this.focusNextInput());
        });
        
        this.inputsContainer.addEventListener("paste", (e) => this.handlePaste(e));
    }
    
    handleInput(event, index) {
        const input = event.target;
        const value = input.value;
        
        // Проверка валидности символа по маске
        if (this.mask && !new RegExp(this.mask).test(value)) {
            input.value = ""; // Сброс невалидного ввода
            return;
        }
        
        // Обновление скрытого input
        this.updateHiddenInput();
        
        // Переключение фокуса
        this.focusNextInput();
        
        // Генерация события ab.ui.codefield.change
        this.triggerEvent("ab.ui.codefield.change");
        
        // Проверка завершенности ввода
        if (this.isComplete()) {
            this.triggerEvent("ab.ui.codefield.complete");
        }
    }
    
    handleKeyDown(event, index) {
        if (event.key === "Backspace") {
            if (this.inputs[index].value) {
                // Удалить текущий символ
                this.inputs[index].value = "";
            } else if (index > 0) {
                // Переместить фокус на предыдущий input и удалить его значение
                this.inputs[index - 1].value = "";
                setTimeout(() => {
                    this.inputs[index - 1].focus();
                }, 10);
            }
            this.updateHiddenInput();
            this.triggerEvent("ab.ui.codefield.change");
        }
    }
    
    handlePaste(event) {
        event.preventDefault();
        const pasteData = (event.clipboardData || window.clipboardData).getData("text").trim();
        
        // Проверка и вставка данных
        if (pasteData.length > 0) {
            let pasteIndex = 0;
            for (let i = 0; i < this.inputs.length; i++) {
                if (pasteIndex >= pasteData.length) break;
                
                const char = pasteData[pasteIndex];
                if (!this.mask || new RegExp(this.mask).test(char)) {
                    this.inputs[i].value = char;
                    pasteIndex++;
                }
            }
            
            this.updateHiddenInput();
            
            // Генерация события ab.ui.codefield.change
            this.triggerEvent("ab.ui.codefield.change");
            
            // Проверка завершенности ввода
            if (this.isComplete()) {
                this.triggerEvent("ab.ui.codefield.complete");
            }
            
            // Установка фокуса на следующий input
            this.focusNextInput();
        }
    }
    
    updateHiddenInput() {
        const validValues = this.inputs.map((input) => (input.value && (!this.mask || new RegExp(this.mask).test(input.value)) ? input.value : "")).join("");
        this.hiddenInput.value = validValues.length === this.charsCount ? validValues : "";
        this.currentValue = this.hiddenInput.value; // Обновляем текущее значение
        this.hiddenInput.dispatchEvent(new Event('change'));
    }
    
    isComplete() {
        return this.inputs.every((input) => input.value && (!this.mask || new RegExp(this.mask).test(input.value))) && this.hiddenInput.value.length === this.charsCount;
    }
    
    focusNextInput() {
        for (let i = 0; i < this.inputs.length; i++) {
            if (!this.inputs[i].value) {
                this.inputs[i].focus();
                return;
            }
        }
        // Если все заполнены, фокусируем на последнем
        if (!this.inputs[this.inputs.length - 1].disabled) {
            this.inputs[this.inputs.length - 1].focus();   
        }
    }
    
    triggerEvent(eventName) {
        const event = new CustomEvent(eventName, {
            detail: { value: this.hiddenInput.value },
        });
        this.container.dispatchEvent(event);
    }
    
    lockInputs() {
        this.inputs.forEach(input => input.disabled = true);
    }
    
    unlockInputs() {
        this.inputs.forEach(input => input.disabled = false);
        this.focusNextInput();
    }
    
    clearInputs() {
        this.inputs.forEach(input => input.value = "");
    }
}

// document.addEventListener('DOMContentLoaded', function() {
//
// });
